/* js.js */
var winH;
var winW;
var pagH;
/*slide home*/
var intervalo;
var tempo = 4000;
var ir = "slideTexto()";
/* fim slide home*/
var animMenu = "inicio";
var idLogo;
var menuFechado = 65;
var docFechado = 1;
var carregamento = 'nenhum';

/*slide home*/
function slideTexto() {
	ir = "slideTexto2()";
	$("#slide-home-img").backstretch("next");
	$('.slide-txt-1').animate({'opacity':0,'top':'35%'}, 500, 'easeOutQuart', function () {
			$('.slide-txt-1').css({'display':'none'})
			$('.slide-txt-1-2').css({'display':'block', 'opacity':'0','top':'45%'})
         			.animate({'opacity':'1','top':'40%'}, 1000, 'easeOutQuart');
		});
	/*$('.slide-txt-1').css('display', 'none');
	$('.slide-txt-1-2').css('display', 'block');*/
	intervalo = setTimeout(ir, tempo);
}
function slideTexto2() {
	ir = "slideTexto3()";
	$("#slide-home-img").backstretch("next");
	$('.slide-txt-1-2').animate({'opacity':0,'top':'35%'}, 500, 'easeOutQuart', function () {
			$('.slide-txt-1-2').css({'display':'none'})
			$('.slide-txt-1-3').css({'display':'block', 'opacity':'0','top':'40%'})
         			.animate({'opacity':'1','top':'35%'}, 1000, 'easeOutQuart');
		});
	/*$('.slide-txt-1-2').css('display', 'none');
	$('.slide-txt-1').css('display', 'block');*/
	intervalo = setTimeout(ir, tempo);
}
function slideTexto3() {
	ir = "slideTexto4()";
	$("#slide-home-img").backstretch("next");
	$('.slide-txt-1-3').animate({'opacity':0,'top':'30%'}, 500, 'easeOutQuart', function () {
			$('.slide-txt-1-3').css({'display':'none'})
			$('.slide-txt-1-4').css({'display':'block', 'opacity':'0','top':'45%'})
         			.animate({'opacity':'1','top':'40%'}, 1000, 'easeOutQuart');
		});
	/*$('.slide-txt-1-2').css('display', 'none');
	$('.slide-txt-1').css('display', 'block');*/
	intervalo = setTimeout(ir, tempo);
}
function slideTexto4() {
	ir = "slideTexto5()"; //slide seguinte
	$("#slide-home-img").backstretch("next");
	$('.slide-txt-1-4').animate({'opacity':0,'top':'30%'}, 500, 'easeOutQuart', function () { //slide atual
			$('.slide-txt-1-4').css({'display':'none'}) //slide atual
			$('.slide-txt-1-5').css({'display':'block', 'opacity':'0','top':'45%'}) // slide seguinte
         			.animate({'opacity':'1','top':'40%'}, 1000, 'easeOutQuart');
		});
	intervalo = setTimeout(ir, tempo);
}
function slideTexto5() {
	ir = "slideTexto6()"; //slide seguinte
	$("#slide-home-img").backstretch("next");
	$('.slide-txt-1-5').animate({'opacity':0,'top':'30%'}, 500, 'easeOutQuart', function () { //slide atual
			$('.slide-txt-1-5').css({'display':'none'}) //slide atual
			$('.slide-txt-1-6').css({'display':'block', 'opacity':'0','top':'45%'}) // slide seguinte
         			.animate({'opacity':'1','top':'40%'}, 1000, 'easeOutQuart');
		});
	intervalo = setTimeout(ir, tempo);
}
function slideTexto6() {
	ir = "slideTexto()"; //slide seguinte
	$("#slide-home-img").backstretch("next");
	$('.slide-txt-1-6').animate({'opacity':0,'top':'30%'}, 500, 'easeOutQuart', function () { //slide atual
			$('.slide-txt-1-6').css({'display':'none'}) //slide atual
			$('.slide-txt-1').css({'display':'block', 'opacity':'0','top':'45%'}) // slide seguinte
         			.animate({'opacity':'1','top':'40%'}, 1000, 'easeOutQuart');
		});
	intervalo = setTimeout(ir, tempo);
}

// Entrada
function entrada() {
	$('.slide-txt-1').animate({'opacity':'1','top':'40%'}, 1000, 'easeOutQuart');
	$('.txtIdentidade').animate({'opacity':'.8','top':'25%'}, 1000, 'easeOutQuart');
	$('.slideControlo, .scrollDownSeta').animate({'opacity':'1'}, 1000, 'easeOutQuart');
}

// Div de abertura com tamanho da janela
function resizeDiv() {
	winW = $(window).width();
	winH = $(window).height();
	if (winW > 768){
		$("#slide-home, #slide-home-img").css({
				"height": winH
			});
	} else {
		$("#slide-home, #slide-home-img").css({
				"height": 500
			});
	}
}

// scroll top
function topo() {
	$('html, body').animate({
		scrollTop:0
		}, 2000, 'easeOutQuart');
	return false;
}

// scroll down
function scrollLink(arg){
	$('html, body').animate({
		scrollTop: $("#div"+arg).offset().top-56
		}, 1500, 'easeOutQuart');
	return false;
}

// assinatura
function assinaturaOver() {
	$("#webdesign").css("visibility","visible");
}
function assinaturaOut() {
	$("#webdesign").css("visibility","hidden");
}


//Abrir Pop UP associados
function abreImagem(arg){
	idLogo = arg;
	$(".capituloImgContentor").fadeOut(100, function(){
		$(".capituloImg").empty();
		$(".capituloNome").empty();
		$(".capituloLinks").empty();
		$(".capituloTexto").empty();

		var imagem = $("#"+arg).children(".ass-imagem").html();
		var nome = $("#"+arg).children(".ass-nome").html();
		var links = $("#"+arg).children(".ass-links").html();
		var texto = $("#"+arg).children(".ass-texto").html();

		$('html, body').css('overflowY', 'hidden');

		$(".capituloImgJanela").fadeIn();
		$(".capituloImgAnterior").css("visibility","visible");
		$(".capituloImgSeguinte").css("visibility","visible");
		$(".capituloImgContentor").fadeIn(500, 'easeInOutQuart');
		$(".capituloImg").append('<img src="'+js_vars.vars.templateurl+'/assets/img/cnt/logos_home/'+imagem+'" />');
		$(".capituloNome").append(nome);
		$(".capituloLinks").append(links);
		$(".capituloTexto").append(texto);
	});
}
//Fecha Pop UP associados
function fechaImagem(){
	$(".capituloImg").empty();
	$(".capituloNome").empty();
	$(".capituloLinks").empty();
	$(".capituloTexto").empty();
	$(".capituloImgJanela").stop().fadeOut();
	$(".capituloImgContentor").stop().fadeOut();
	$('html, body').css('overflowY', 'auto');
}


//centra password membros
function centraPassword(){
	winH = $(window).height();
	var passAltura = $(".membrosPass_contentor").height();
	var passTop = (winH - passAltura)/2;
	if (passTop > 150){
		   $('.membrosPass_contentor').css( "margin-top", passTop );
	   } else {
			$('.membrosPass_contentor').css( "margin-top", 150 );
	   }
}

/* MAP FEATURES */
function initialize_map() {
	geocoder = new google.maps.Geocoder();
	var latCentro = new google.maps.LatLng(38.7284444, -9.1480514); //centro do mapa
	var latlng = new google.maps.LatLng(38.7284444, -9.1480514); // local assinalado
	var styles = [
	  {
		stylers: [
		  { saturation: -100 },
		  { lightness: 50 },
		  { gamma: 0.6 }
		]
	  },{
		featureType: "road",
		elementType: "geometry",
		stylers: [
		  { lightness: 100 },
		  { visibility: "simplified" }
		]
	  },{
		featureType: "poi",
		elementType: "labels",
		stylers: [
		  { visibility: "simplified" }
		]
	  },{
		featureType: "water",
		elementType: "geometry",
		stylers: [
		  { lightness: -8 }
		]
	  }


	];

	var mapOptions = {
		center: latCentro,
		zoom: 15,
		mapTypeControl: true, // mapa ou satélite
		mapTypeControlOptions: {
		style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
		position: google.maps.ControlPosition.TOP_CENTER
		},
		zoomControl: true, // zoom
		zoomControlOptions: {
		style: google.maps.ZoomControlStyle.SMALL,
		position: google.maps.ControlPosition.LEFT_CENTER
		},
		scrollwheel:  false,
		styles: styles
	};

	var map = new google.maps.Map(document.getElementById("map-canvas"), mapOptions);

	var marker = new google.maps.Marker({
	position: latlng,
	map: map,
	title: 'ANEBE'
	});
	google.maps.event.addListener(marker, 'click', function() {
		window.open("https://www.google.pt/maps/place/Av.+Fontes+Pereira+de+Melo+16,+1050-010+Lisboa/@38.7284447,-9.1502398,17z/data=!3m1!4b1!4m5!3m4!1s0xd193375d6a63ca5:0xfdaac1ba3274ba47!8m2!3d38.7284447!4d-9.1480511");
	});
}

(function($) {
	"use strict"; // Start of use strict
	$(window).scroll( function() {
		var winW = $(window).width();
		if (winW > 850){
		   var novoScroll = $(this).scrollTop();
		   if (novoScroll > 50){
			   $('.contentorMenu').removeClass( "menuEstende" );
			   $('.contentorMenu').addClass( "menuRecolhe" );
			   animMenu = "iniciado";
		   } else if (novoScroll < 50 & animMenu == 'iniciado' ){
				$('.contentorMenu').removeClass( "menuRecolhe" );
			   $('.contentorMenu').addClass( "menuEstende" );
		   }
		}

		//aparece o video da home
		var winH = $(window).height();
		var scrolled = $(window).scrollTop();
		if ($('.overlay').length) {
			var Vposicao = $('.overlay').offset().top-winH;
			var videoH = $('.overlay').height();
			if (Vposicao <= scrolled & Vposicao+winH+videoH>=scrolled) {
				$('.hero-vid').css('display', 'block');
			} else {
				$('.hero-vid').css('display', 'none');
			}
		}

		//slide da home deixa de ser fixo
		if (scrolled > winH & winW > 768) {
			$("#slide-home-img").css('position', 'absolute');
		} else {
			$("#slide-home-img").css('position', 'fixed');
		}
	});
	$(window).resize( function() {
		resizeDiv();
		centraPassword();
	});
	$(window).ready(function() {
		var hpImages = [];
		$('.hp-slide-txt').each(function() {
			hpImages.push($(this).data('img'));
		});
		if (hpImages.length>0) {
			$("#slide-home-img").backstretch(hpImages, {
				paused: true,
				fade: 750
			});
		}

		$(".logosHome").slick({
				dots: false,
				infinite: true,
				slidesToShow: 6,
				slidesToScroll: 6,
				autoplay: true,
				autoplaySpeed: 6000,
				speed: 1000,
				responsive: [{
				breakpoint: 1250,
				settings: {
					slidesToShow: 5,
					slidesToScroll: 5,
				}
			}, {
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 4,
					autoplaySpeed: 4000,
				}
			}, {
				breakpoint: 768,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					autoplaySpeed: 3000,
				}
			}, {
			breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					autoplaySpeed: 2000,
				}
			}]
		});

		$(".testemunhosHome").slick({
			dots: false,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 6000,
			speed: 1000
		});


		resizeDiv();

		$('.btTopo').click(topo);

		$('#assinatura').hover(function(){
			assinaturaOver();
		}, function(){
			assinaturaOut();
		});

		/*slide home*/
		entrada();
		$('.btNext, .btPrev').click(function(){
			tempo = 10000;
			clearTimeout(intervalo);
			eval(ir);
		});
		/*slide home*/

		$('.goScroll').click(function(){
			var idTemp = $(this).attr('id');
			scrollLink(idTemp);
		});


		/*Logos de associados*/
		$('.logosContentor').click(function(){
			var idTemp = $(this).attr('id');
			abreImagem(idTemp);
		});

		$('.capituloImgFechar').click(function(){
			fechaImagem();
		});

		$('.capituloImgSeguinte').click(function () {
			var $el = $('.logosAssociados ul li #'+idLogo);
			var $next = $el.parent().next();
			if($next.length == 0){
				$(".capituloImgSeguinte").css("visibility","hidden");
			} else{
				var idAbrir = $next.find('.logosContentor').attr('id');
				abreImagem(idAbrir);
				$(".capituloImgAnterior").css("visibility","visible");
			}
		});


		$('.capituloImgAnterior').click(function () {
			var $el = $('.logosAssociados ul li #'+idLogo);
			var $prev = $el.parent().prev();
			if($prev.length == 0){
				$(".capituloImgAnterior").css("visibility","hidden");
			} else{
				var idAbrir = $prev.find('.logosContentor').attr('id');
				abreImagem(idAbrir);
				$(".capituloImgSeguinte").css("visibility","visible");
			}
		});
		/* fim de Logos de associados*/

		//Notícias
		$('.noticiasTit').click(function(){
			console.log('here');
			if (!$(this).hasClass('in-detail')) {
				var gaveta = $(this).parents().eq(1).find(".gaveta").attr('id');
				var alturaTotal = document.getElementById(gaveta).scrollHeight;
				var alturaCortada = $("#"+gaveta).height();
				if (alturaCortada <= menuFechado) {
					$("#"+gaveta).animate({"max-height": alturaTotal}, 500, 'easeOutQuart');
					$(this).css({"background":"url("+js_vars.vars.templateurl+"/assets/img/cnt/seta_noticias_over.png) right top no-repeat"});
				} else {
					$("#"+gaveta).animate({"max-height": menuFechado}, 500, 'easeOutQuart');
					$(this).css({"background":"url("+js_vars.vars.templateurl+"/assets/img/cnt/seta_noticias.png) right top no-repeat"});
				}
			}
		});

		//Documentos
		$('.puxador').click(function(){
			var gaveta = $(this).parents().eq(1).find(".gaveta").attr('id');
			var alturaTotal = document.getElementById(gaveta).scrollHeight;
			var alturaCortada = $("#"+gaveta).height();
			if (alturaCortada <= docFechado) {
			  $("#"+gaveta).animate({"max-height": alturaTotal}, 500, 'easeOutQuart');
			  $(this).css({"background":"url("+js_vars.vars.templateurl+"/assets/img/cnt/seta_noticias_over.png) right top no-repeat"});
			} else {
			  $("#"+gaveta).animate({"max-height": docFechado}, 500, 'easeOutQuart');
			  $(this).css({"background":"url("+js_vars.vars.templateurl+"/assets/img/cnt/seta_noticias.png) right top no-repeat"});
			}
		});

		centraPassword();

		if ($('body').hasClass('homepage')) {
			//inicia o slideshow
			intervalo = setTimeout(slideTexto, tempo);
		}
	});
	$(window).on('load',function() {
	   //aparece o video da home
	   var winH = $(window).height();
	   var scrolled = $(window).scrollTop();
	   if ($('.overlay').length) {
			var Vposicao = $('.overlay').offset().top-winH;
			var videoH = $('.overlay').height();
			if (Vposicao <= scrolled & Vposicao+winH+videoH>=scrolled) {
				$('.hero-vid').css('display', 'block');
			} else {
				$('.hero-vid').css('display', 'none');
			}
	   }

	   //slide da home deixa de ser fixo
	   if (scrolled > winH & winW > 768) {
		   $("#slide-home-img").css('position', 'absolute');
	   } else {
		   $("#slide-home-img").css('position', 'fixed');
	   }

	   $('.membrosPass').fadeIn(500, 'easeInOutQuart');
	   centraPassword();

		if ($('#map-canvas').length) {
			initialize_map();
		}

		if ($('form #enviar').length) {
			$('form #enviar').bind('click',function(ev) {
				$(this).closest('form.wpcf7-form').find('.wpcf7-submit').click();
				$(this).blur(); ev.preventDefault();
			});
		}

		/* LOGIN FEATURES - rjml */
		$('.membrosPass #entrar').bind('click',function(ev) {
			var lpass = $('#lpass').val();

			$('.membrosPass .formularioAlerta').hide();

			$.ajax({ type: 'POST', url: js_vars.vars.ajaxurl, data: { 'lpass' : lpass, 'action': 'submit_login' }, success: function (result) {
				if (result=='success') {
					//Cookies.set('custom_login', '1', { expires: 30 });
					location.reload();
				}else{
					$('.membrosPass .formularioAlerta').show();
				}
			}, error: function () {} });
			$(this).blur(); ev.preventDefault();
		});
		$('.logout-user').bind('click',function(ev) {
			$.ajax({ type: 'POST', url: js_vars.vars.ajaxurl, data: { 'action': 'logout_members' }, success: function (result) {
				//Cookies.remove('custom_login');
				location.reload();
			}, error: function () {} });
			$(this).blur(); ev.preventDefault();
		});

	});
})(jQuery); // End of use strict

/* _main.js */
( function( $ ) {

	// Setup variables
	$window = $(window);
	$slideG = $('.slideGrande');
	$slideM = $('.slideMedio');
	$slideP = $('.slidePequeno');
	$body = $('body');

    //FadeIn all sections
	$body.imagesLoaded( function() {
		setTimeout(function() {

		      // Resize sections
		      adjustWindow();

		      // Fade in sections
			  $body.removeClass('loading').addClass('loaded');

		}, 800);
	});

	function adjustWindow(){

	    // Get window size
	    winH = $window.height();
		janelaHm = $window.height()/5*3;
		janelaH = 400;
	    winW = $window.width();

	    // Keep minimum height 550
	    if(winH <= 400) {
	        winH = 400;
	    }

	    // Init Skrollr for 768 and up
	    if( winW > 1024) {

	        // Init Skrollr
	        var s = skrollr.init({
	            forceHeight: false
	        });

	        // Resize our slides
	        $slideG.height(winH);
			$slideM.height(janelaHm);
			$slideP.height(janelaH);

	        s.refresh($('.slideGrande'));
			s.refresh($('.slideMedio'));
			s.refresh($('.slidePequeno'));

	    } else {

	        // Init Skrollr
	        var s = skrollr.init();
	        s.destroy();
	    }

		// Check for touch
	   	if(Modernizr.touch) {

			// Init Skrollr
			var s = skrollr.init();
			s.destroy();
	   	}

	}

	function initAdjustWindow() {
	    return {
	        match : function() {
	            adjustWindow();
	        },
	        unmatch : function() {
	            adjustWindow();
	        }
	    };
	}

	enquire.register("screen and (min-width : 1024px)", initAdjustWindow(), false).listen(100);

} )( jQuery );

/* hamburguer animation */
/*animação do hamburguer*/
(function() {
	"use strict";
	var toggles = document.querySelectorAll(".c-hamburger");
	for (var i = toggles.length - 1; i >= 0; i--) {
		var toggle = toggles[i];
		toggleHandler(toggle);
	};
	function toggleHandler(toggle) {
		toggle.addEventListener( "click", function(e) {
			e.preventDefault();
			(this.classList.contains("is-active") === true) ? this.classList.remove("is-active") : this.classList.add("is-active");
		});
	}
})();

/* clique no hamburguer*/
$(function(){
	var nav = $('.hamburguerDiv'),
		animateTime = 1000,
		navLink = $('.hamburguerDiv .c-hamburger, .menu li a'),
		aberturaInicial = 95,
		aberturaFinal = 1000;
	navLink.click(function(){
		if(nav.height() === aberturaInicial){
			nav.stop().animate({ 'max-height': aberturaFinal }, animateTime);
		} else {
			nav.stop().animate({ 'max-height': aberturaInicial }, animateTime);
		}
	});
});

/* SCROLL REVEAL */
window.sr = ScrollReveal({
	scale: 1,
	viewFactor: 0.5,
	distance: '100px',
	duration: 500,
	easing: 'ease-out',
	mobile: false,
	useDelay: 'onload'
});
sr.reveal('.anim');
